import styled from '@emotion/styled';
import React from 'react';
import Image1 from '../../images/image5.png';
import Image2 from '../../images/image6.png';
import Image3 from '../../images/image7.png';
import Image4 from '../../images/image8.png';
import Image5 from '../../images/image9.png';
import Image6 from '../../images/image10.png';
import Image7 from '../../images/image11.png';
import Image8 from '../../images/image12.png';
import Image9 from '../../images/image13.png';

const GallerySection = styled.div`
  display:flex;
  flex-direction: column;
  gap: 16px;
  flex: 1 0 auto;
  padding: 16px;
  border-radius: 16px;
  border: 1px solid ${(props) => props.theme.colors.gray};
  position: relative;
`;

export default function GalleryPage() {
  return (
        <GallerySection>
            <h3 className='new-h3'>Галерея</h3>
            <div className='account-gallery-relative-warpper'>
                <div className="account-gallery-wrapper u-fancy-scrollbar">
                    <div className='account-gallery-item'>
                        <img src={Image1} />
                    </div>
                    <div className='account-gallery-item'>
                        <img src={Image2} />
                    </div>
                    <div className='account-gallery-item'>
                        <img src={Image3} />
                    </div>
                    <div className='account-gallery-item'>
                        <img src={Image4} />
                    </div>
                    <div className='account-gallery-item'>
                        <img src={Image5} />
                    </div>
                    <div className='account-gallery-item'>
                        <img src={Image6} />
                    </div>
                    <div className='account-gallery-item'>
                        <img src={Image7} />
                    </div>
                    <div className='account-gallery-item'>
                        <img src={Image8} />
                    </div>
                    <div className='account-gallery-item'>
                        <img src={Image9} />
                    </div>
                </div>
            </div>
        </GallerySection>
  );
}